<template>
  <v-chip-group
    :value="value"
    mandatory
    show-arrows
    class="item-type-chips"
    active-class="primary--text"
    @change="type => $emit('input', type === undefined ? null : type)"
  >
    <v-chip small outlined :value="null">{{ $t('items.all_types') }}</v-chip>
    <v-chip v-for="type in types" :key="type" small outlined :value="type">{{ typeLabel(type) }}</v-chip>
  </v-chip-group>
</template>

<script>
import { typePluralName } from '@/helpers/itemTypes';

/**
 * Nimiketyyppien pillerinauha "Kaikki | Teräsputket | ...". Arvo on tyypin id tai null (kaikki).
 * Käytössä nimikevalinnassa (ItemCombobox) ja Nimikkeet-näkymässä.
 */
export default {
  name: 'ItemTypeChips',
  props: {
    value: {
      type: Number,
      default: null,
    },
    // Tyyppien id:t näyttöjärjestyksessä.
    types: {
      type: Array,
      required: true,
    },
  },
  methods: {
    typeLabel(typeId) {
      return typePluralName(typeId);
    },
  },
};
</script>

<style scoped>
/* commonstyles.scss piilottaa .v-slide-group__prev:n kaikkialta (mobiilitabit); pillerinauha tarvitsee molemmat nuolet. */
.item-type-chips ::v-deep .v-slide-group__prev {
  display: flex !important;
}
</style>
